import * as React from 'react';

import type { ApolloError } from '@apollo/client';

import { NotFound as NotFoundPage } from 'bundles/common/components/withNotFound';
import { InternalServerError, NotFoundError } from 'bundles/ssr/lib/errors/directives';
import inServerContext from 'bundles/ssr/util/inServerContext';

const GRAPHQL_NOT_FOUND_CODE = 'NOT_FOUND';

const NotFound = () => {
  // If on server, serve a true 404 (edge will handle rendering 404 page).
  if (inServerContext) {
    throw new NotFoundError();
  } else {
    return <NotFoundPage />;
  }
};

const InternalError = ({ pathname }: { pathname: string }) => {
  // If on server, serve a true 500 (edge will handle rendering internal server error page).
  if (inServerContext) {
    throw new InternalServerError(pathname);
  } else {
    // We don't have a component for internal errors, default to showing not found.
    return <NotFoundPage />;
  }
};

// This is used when DescriptionPages queries complete w/ no data.
// If error is defined, we attempt to surface a correct response.
// If not, we default to a 404 page (which is the likely scenario).
const PageDataErrorHandler = ({ pathname, error }: { pathname: string; error?: ApolloError }) => {
  if (!error || error.graphQLErrors?.[0]?.extensions?.errorType === GRAPHQL_NOT_FOUND_CODE) {
    return <NotFound />;
  } else {
    return <InternalError pathname={pathname} />;
  }
};

export default PageDataErrorHandler;
